/* import __COLOCATED_TEMPLATE__ from './standalone-platform-handoff.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type StandalonePlatformHandoff from 'embercom/objects/inbox/renderable/standalone-platform-handoff';

export interface StandalonePlatformHandoffSignature {
  Args: {
    part: RenderablePart & { renderableData: StandalonePlatformHandoff };
  };
}

export default class StandalonePlatformHandoffPartComponent extends Component<StandalonePlatformHandoffSignature> {
  @service declare intl: IntlService;

  get renderableData() {
    return this.args.part.renderableData;
  }

  get textToDisplay(): string {
    let handoffType = this.renderableData.handoffType;
    let handoffStage = this.renderableData.handoffStage;
    let handoffSuccess = this.renderableData.handoffSuccess;

    let platformName = handoffType
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    let localizationPrefix = 'inbox.operator-workflow-event.events.standalone_platform_handoff';

    if (handoffStage === 'initiated') {
      return this.intl.t(`${localizationPrefix}.initiated`, { platform: platformName });
    }

    return handoffSuccess
      ? this.intl.t(`${localizationPrefix}.success`, { platform: platformName })
      : this.intl.t(`${localizationPrefix}.failure`, { platform: platformName });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::StandalonePlatformHandoff': typeof StandalonePlatformHandoffPartComponent;
    'inbox2/conversation-stream/event-parts/standalone-platform-handoff': typeof StandalonePlatformHandoffPartComponent;
  }
}
